export default "__VITE_ASSET__DnP3YcAV__"